let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gn85Y")).then(() => parcelRequire('8QV3v'));